/**
 * 오더 매칭 타입 통계 모달 ($j.Ui.JBModal.target 결합).
 * 레거시 /adm/order/match/percent (blade) 대체.
 *
 * 사용법:
 *   $j.Ui.JBModal.target('match-percent-modal', {
 *       target: '$j.F.Admin.Order.MatchPercent',
 *       data:   { ordernum: 12345 },
 *       title:  '통계',
 *       width:  '900px',
 *   });
 *
 * 데이터: GET /adm/ajax/order/match/percent?ordernum=&gcode=
 *   → { carDB:[{code,eng_name,...}], list:[{ordernum,car_codes,match_type}], sidoList:[{gcode,gname}], gcode, limit }
 */
export default class MatchPercent {
    constructor() { this.$wrap = null; }
    destroy() {}

    init() {
        this.modalId = 'match-percent-modal';
        this.ordernum = this.data.ordernum;
        this.gcode = '';
        $(`#${this.id}`).html('<div style="padding:20px;text-align:center;color:#888">로딩중...</div>');
        this.load();
    }

    load() {
        const self = this;
        $.ajax({
            type: 'get',
            url: '/adm/ajax/order/match/percent',
            data: { ordernum: self.ordernum, gcode: self.gcode },
            dataType: 'json',
            success(data) {
                self.state = data;
                self.gcode = data.gcode;
                self.render();
                self.bind();
            },
            error() {
                $(`#${self.id}`).html('<div style="padding:20px;text-align:center;color:var(--adm-kw-red, red)">데이터를 불러오지 못했습니다.</div>');
            },
        });
    }

    render() {
        const s = this.state;

        const sidoOpts = s.sidoList.map(r =>
            `<option value="${r.gcode}" ${r.gcode == s.gcode ? 'selected' : ''}>${r.gname}</option>`
        ).join('');

        // 현재 오더가 list 의 몇 번째 열인지 (같은 지역일 때만 존재)
        const curIdx = s.list.findIndex(r => String(r.ordernum) === String(this.ordernum));

        // 열 = 최근 오더 (왼쪽이 최신). 현재 오더 열은 ▼ 마커로 강조
        const headerCells = s.list.map((_, i) =>
            i === curIdx
                ? `<th class="mp-col mp-cur" title="현재 오더">▼</th>`
                : `<th class="mp-col">${i + 1}</th>`
        ).join('');

        // 셀 하나 = (톤수코드 × 오더). 표기는 $j.F.Admin.MatchTag 로 통일한다 —
        // 예전엔 색만 칠한 빈 네모라 세대(ver)를 알 수 없었고 배분분포 화면과도 표기가 갈렸다.
        const T = $j.F.Admin.MatchTag;
        const codeIndex = {};
        s.list.forEach((row, i) => {
            (row.car_codes || '').split(',').forEach(c => {
                if (!codeIndex[c]) codeIndex[c] = {};
                codeIndex[c][i] = row;
            });
        });

        let ncCnt = 0, nsCnt = 0;
        const rows = s.carDB.map(v => {
            const cells = s.list.map((row, i) => {
                const hit = codeIndex[v.code]?.[i];
                const cls = hit ? T.cls(hit.match_type) : 'is-none';
                if (cls === 'is-nc') ncCnt++;
                else if (cls === 'is-ns') nsCnt++;
                const tdCls = i === curIdx ? 'mp-td mp-cur' : 'mp-td';
                const body  = hit
                    ? `<span class="mcell ${cls}" title="오더 ${hit.ordernum} · ${T.text(hit.match_type, hit.match_ver)}">${T.code(hit.match_type, hit.match_ver)}</span>`
                    : '<span class="mcell is-none"></span>';
                return `<td class="${tdCls}">${body}</td>`;
            }).join('');
            return `<tr><td class="mp-lbl">${this._esc(v.eng_name)}</td>${cells}</tr>`;
        }).join('');

        const html = `
        <style>
            #${this.id} .mp-wrap { font-family:'Malgun Gothic',"맑은 고딕",AppleGothic,sans-serif; color:#374151; }
            #${this.id} .mp-head { display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; margin-bottom:14px; }
            #${this.id} .mp-head select { height:34px; padding:4px 12px; border:1px solid #cbd5e1; border-radius:8px; font-size:14px; background:#fff; min-width:140px; }
            #${this.id} .mp-legend { display:flex; align-items:center; gap:14px; font-size:13px; color:#475569; }
            #${this.id} .mp-legend i { display:inline-block; width:12px; height:12px; border-radius:3px; margin-right:5px; vertical-align:-1px; }
            #${this.id} .mp-legend-note { color:#94a3b8; font-size:12px; }
            #${this.id} .mp-legend .lg-nc { background:#22c55e; } #${this.id} .mp-legend .lg-ns { background:#ef4444; }
            #${this.id} .mp-scroll { width:100%; overflow-x:auto; -webkit-overflow-scrolling:touch; border:1px solid #e5e7eb; border-radius:10px; }
            #${this.id} table.mp-tbl { border-collapse:separate; border-spacing:0; width:max-content; min-width:100%; font-size:12px; }
            #${this.id} .mp-tbl th.mp-col, #${this.id} .mp-tbl td.mp-td { min-width:28px; }
            #${this.id} .mp-tbl th { background:#f8fafc; color:#475569; font-weight:700; padding:8px 6px; border-bottom:1px solid #e5e7eb; text-align:center; white-space:nowrap; }
            #${this.id} .mp-tbl th.mp-col { width:24px; font-size:11px; color:#94a3b8; font-weight:500; }
            #${this.id} .mp-tbl th:first-child, #${this.id} .mp-tbl td.mp-lbl { position:sticky; left:0; z-index:1; background:#f8fafc; text-align:left; padding-left:14px; font-weight:700; color:#334155; white-space:nowrap; box-shadow:1px 0 0 #e5e7eb; }
            #${this.id} .mp-tbl tbody tr:nth-child(even) td.mp-lbl { background:#fcfdfe; }
            #${this.id} .mp-tbl td.mp-td { padding:3px; text-align:center; }
            #${this.id} .mp-tbl tbody tr:not(:last-child) td { border-bottom:1px solid #f1f5f9; }
            /* 셀 자체(.mcell)는 components/_match-tag.scss 공용 — 여기선 가운데 정렬만 */
            #${this.id} .mp-tbl td.mp-td .mcell { margin:0 auto; }
            /* 현재 오더 열 강조 */
            #${this.id} .mp-tbl th.mp-cur { background:#1d4ed8; color:#fff; font-size:12px; }
            #${this.id} .mp-tbl td.mp-cur { background:#eff6ff; box-shadow:inset 1px 0 0 #bfdbfe, inset -1px 0 0 #bfdbfe; }
            #${this.id} .mp-foot { margin-top:10px; font-size:12px; color:#94a3b8; text-align:right; }
            #${this.id} .mp-foot .mp-cur-note { color:#1d4ed8; font-weight:700; }
        </style>
        <div class="mp-wrap">
            <div class="mp-head">
                <select id="mp-gcode">${sidoOpts}</select>
                <div class="mp-legend">
                    <span><i class="lg-nc"></i>NC 일반 ${ncCnt}</span>
                    <span><i class="lg-ns"></i>NS 미수주자용 ${nsCnt}</span>
                    <span class="mp-legend-note">칸 글자 = 유형+세대 (C4 = NC ver4)</span>
                </div>
            </div>
            <div class="mp-scroll">
                <table class="mp-tbl">
                    <thead><tr><th>톤수</th>${headerCells}</tr></thead>
                    <tbody>${rows}</tbody>
                </table>
            </div>
            <div class="mp-foot">선택 지역의 최근 ${s.list.length}건 당일외 오더 · 열 오른쪽이 최신${curIdx >= 0 ? ' · <span class="mp-cur-note">▼ 현재 오더</span>' : ''}</div>
        </div>`;
        $(`#${this.id}`).html(html);
        this.$wrap = $(`#${this.id}`);
    }

    bind() {
        const self = this;
        this.$wrap.find('#mp-gcode').off('change').on('change', function () {
            self.gcode = $(this).val();
            self.load();
        });
    }

    _esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }
}
